<template>
	<div class="main">
		<popupLayout>
			<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
			<div class="bootbox-body" style="overflow-y:auto;">
				<section class="panel">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-12 text-right form-inline" >
								<a href="javascript:;" class="btn btn-danger m-xs" @click="violateType={}; modifyUrl='/api/Common/addCommCode'; isAddPopupShow=true;">新增</a>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-12">
								<table class="col-md-12 table-bordered">
									<thead>
										<tr>
											<td colspan="2" style="width:20%; text-align:center;">編輯</td>
											<td style="width:60%; text-align:center;">名稱</td>
											<td style="width:20%; text-align:center;">獎勵/違規</td>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in violateTypeList" :key="item.commCode">
											<td style="text-align:center;">
												<a href="javascript:;" class="btn btn-link" @click="violateType=item;  modifyUrl='/api/Common/modifyCommCodeByCode'; isAddPopupShow=true;">修改</a>
											</td>
											<td style="text-align:center;">
												<a href="javascript:;" class="btn btn-link" @click="violateType=item; modifyUrl='/api/Common/romoveCommCode'; modifyViolateType();">刪除</a>
											</td>
											<td style="text-align:center;">{{item.commValue}}</td>
											<td style="text-align:center;">違規</td>
										</tr>
										<tr v-for="item in awardTypeList" :key="item.commCode">
											<td style="text-align:center;">
												<a href="javascript:;" class="btn btn-link" @click="violateType=item;  modifyUrl='/api/Common/modifyCommCodeByCode'; isAddPopupShow=true;">修改</a>
											</td>
											<td style="text-align:center;">
												<a href="javascript:;" class="btn btn-link" @click="violateType=item; modifyUrl='/api/Common/romoveCommCode'; modifyViolateType();">刪除</a>
											</td>
											<td style="text-align:center;">{{item.commValue}}</td>
											<td style="text-align:center;">獎勵</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</section>
			</div>
		</popupLayout>
		<popupLayout v-if="isAddPopupShow">
			<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="isAddPopupShow = false">×</button>
			<div class="bootbox-body">
				<section class="panel">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-12">
								<label for="" class="col-md-2">獎勵/違規</label>
								<div class="col-md-4 form-inline">
									<label for="isPrize_Y">
										<input type="radio" class=" form-control" name="commType" value="AWARD" v-model="violateType.commType"/> 獎勵
									</label>
									&emsp;
									<label for="isPrize_N">
										<input type="radio" class=" form-control" name="commType" value="VIOLATE" v-model="violateType.commType"/> 違規
									</label>
								</div>

							</div>
							<div class="col-md-12">
								<label for="" class="col-md-2">
									<span v-if="violateType.commType == 'AWARD'">獎勵</span>
									<span v-if="violateType.commType == 'VIOLATE'">違規</span>
									名稱
								</label>
								<div class="col-md-10">
									<input type="hidden" v-model="violateType.commCode" />
									<input type="text" class="form-control" name="name" v-model="violateType.commValue" maxlength="50"/>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-offset-10 col-md-2 text-left">
								<button type="button" class="btn btn-danger btn-block" @click="modifyViolateType()">儲存</button>
							</div>
						</div>
					</div>
				</section>
			</div>
		</popupLayout>
	</div>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	mounted(){
		this.init();
	},
	data(){
		return{
			violateType:{},
			violateTypeList:[],
			awardTypeList:[],
			isAddPopupShow:false,
			modifyUrl:"",
		}
	},
	methods:{
		init(){
			let _this = this;
			const api = "/api/Common/violateList";
			this.$axios.post(api, JSON.stringify({})).then(resp => {
				this.violateTypeList = resp.data.data.filter(item => {
					return item.commType == "VIOLATE";
				});
				this.awardTypeList = resp.data.data.filter(item => {
					return item.commType == "AWARD";
				});
			});
		},
		modifyViolateType(){
			let _this = this;
			this.$axios.post(this.modifyUrl, JSON.stringify(this.violateType)).then(resp => {
				bootbox.alert(resp.data.msg, function(){
					if(resp.data.status == "success"){
						_this.init();
						_this.isAddPopupShow = false;
					}
				});
			});
		},
		closePopup() {
			this.$parent.showViolatePopupControl(false);
		}
	}
}
</script>
<style scoped>
@media only screen and (max-device-height : 667px){
	.bootbox-body{
		max-height:480px;
		overflow-y:auto;
	}
}
@media only screen and (max-device-height : 736px) {
	.bootbox-body{
		max-height:600px;
		overflow-y:auto;
	}
}
@media only screen and (min-device-height : 736px) {
	.bootbox-body{
		max-height:620px;
		overflow-y:auto;
	}
}
</style>
